import React from 'react';
import Section from './Section/Section';

function Game() {
    return (
        <div className="Tv">
            <Section
                searchText="game"
            />
        </div>
    )
}

export default Game